// extracted by mini-css-extract-plugin
export default {"root":"UnifiedMatrix_root__tGjca","header":"UnifiedMatrix_header__gjqSl","body":"UnifiedMatrix_body__AJJVd"};